export default {
  PROFILE:  '/setup/profile',
  NAME:  '/setup/name',
  NAME_CONTACT:  '/setup/name-contact',
  ZIP_CODE: '/setup/zip-code',
  ORGANIZATION:  '/setup/organization',
  SCHOOL:  '/setup/school',
  EDUCATOR_VALUE:  '/setup/educator-value',
  EDUCATOR_VALUE_YES:  '/setup/educator-value-yes',
  EDUCATOR_VALUE_NO:  '/setup/educator-value-no',
  PARTNER_VALUE:  '/setup/partner-value',
  PARTNER_VALUE_YES:  '/setup/partner-value-yes',
  PARTNER_VALUE_NO:  '/setup/partner-value-no',
  EDUCATOR_INTENT_SCHOOL:  '/setup/educator-intent-school',
  EDUCATOR_INTENT_ORGANIZATION:  '/setup/educator-intent-organization',
  PARTNER_INTENT:  '/setup/partner-intent',
  TEACHING:  '/setup/teaching',
  PRACTICES:  '/setup/practices',
  PAST_ENGAGEMENT:  '/setup/past-engagement',
  CONTACT: '/setup/contact',
  ABOUT: '/setup/about',
  SKILLS: '/setup/skills',
  SKILLS_INTRODUCTION: '/setup/skills-introduction',
  INTERESTS: '/setup/interests',
  ACTIVITY_TYPES: '/setup/activities',
  EXPERIENCE: '/setup/experience',
  MOTIVATION: '/setup/motivation',
  HOPE: '/setup/hope',
  SOCIAL: '/setup/social',
  DEMOGRAPHICS: '/setup/demographics',
  AVATAR: '/setup/avatar',
  END: '/setup/end',
  FINISH: '/setup/finish',
  NETWORK: '/setup/network',
  THANKS: '/setup/thanks',
  UNAVAILABLE: '/setup/unavailable',
  // END_VIEW_PROFILE: (user) => `/profile/view?welcome=show`,
  END_VIEW_PROFILE: (user) => `/`,
  DASHBOARD: '/',
  REDIRECT:  '/setup/redirect',
  REDIRECT_EDUCATOR_YES:  '/setup/redirect-educator-yes',
  REDIRECT_EDUCATOR_NO:  '/setup/redirect-educator-no',
  REDIRECT_PARTNER_YES:  '/setup/redirect-partner-yes',
  REDIRECT_PARTNER_NO:  '/setup/redirect-partner-no',
  REDIRECT_UNKNOWN:  '/setup/redirect-unknown'
};
